import { SIZE } from '../../../constants/size'
import { useScreen } from '../../../hooks'
import { FormModal } from '../../Form'
import { useResizeModal } from '../../Modal'
import { useWysiwygEditorFullScreenHeight } from '../../WysiwygEditor'

import {
  NEWSBOARD_POST_PROFILE_EDIT_MESSAGE_MODAL_QA_NAME,
  NEWSBOARD_POST_PROFILE_EDIT_MESSAGE_MODAL_SUBMIT_QA_NAME,
} from './NewsboardPostProfileEditMessageModal.constants'
import { NewsboardPostProfileEditMessageModalFields } from './NewsboardPostProfileEditMessageModalFields'

function NewsboardPostProfileEditMessageModal({
  Fields = NewsboardPostProfileEditMessageModalFields,
  ticker,
  ...restProps
}) {
  const { isMobileScreenSize } = useScreen()

  const { fullScreen, handleResizeModal } = useResizeModal()

  const isFullScreen = isMobileScreenSize || fullScreen

  const { contentRef, contentWrapperRef, editorRef, handleEditorInit } =
    useWysiwygEditorFullScreenHeight({ isFullScreen })

  return (
    <FormModal
      {...restProps}
      Fields={Fields}
      containerProps={{
        boxSize: SIZE.X_LARGE,
        isFullScreen,
        qaName: NEWSBOARD_POST_PROFILE_EDIT_MESSAGE_MODAL_QA_NAME,
        onResize: isMobileScreenSize ? null : handleResizeModal,
      }}
      formBodyProps={{
        contentProps: {
          contentRef,
          contentWrapperRef,
          isFullScreen,
          size: SIZE.X_LARGE,
        },
        submitQaName: NEWSBOARD_POST_PROFILE_EDIT_MESSAGE_MODAL_SUBMIT_QA_NAME,
      }}
      formFieldsProps={{ editorRef, ticker, onInitEditor: handleEditorInit }}
      formTitle='NewsboardPostProfile.EditMessageModalTitleKey'
    />
  )
}

export default NewsboardPostProfileEditMessageModal
